import * as api from '../../api/api-implicado-client';
import { 
    GET_GRILLA_IMPLICADO,
    GET_DATOS_PANTALLA,
    GET_COMBO_SEGURO,
    GET_COMBO_COMPANIAS,
    GET_COMBO_VEHICULOS,
    GET_COMBO_MARCAS,
    GET_COMBO_PAIS,
    GET_COMBO_COMUNAS,
    POST_ACTUALIZAR_IMPLICADO,
    OBTENER_DATOS_NO_FORMATOS,
    OBTENER_RUT_CONDUCTOR,
    OBTENER_RUT_PROPIETARIO,
    GET_PARAMETROS
 
} from '../types';

export const obtenerGrillaImplicado = (query) => ({
    type: GET_GRILLA_IMPLICADO,
    payload: api.getGrillaImplicado(query)
});
export const obtenerParametros = (query) => ({
    type: GET_PARAMETROS,
    payload: api.getParametrosFecha(query)
});
export const obtenerDatosPantalla = (query) => ({
    type: GET_DATOS_PANTALLA,
    payload: api.getDatosPantalla(query)
});
export const obtenerComboSeguro = (query) => ({
    type: GET_COMBO_SEGURO,
    payload: api.getComboSeguro(query)
});
export const obtenerComboCompanias = (query) => ({
    type: GET_COMBO_COMPANIAS,
    payload: api.getComboCompanias(query)
});
export const obtenerComboVehiculos = (query) => ({
    type: GET_COMBO_VEHICULOS,
    payload: api.getComboTipoVehiculo(query)
});
export const obtenerComboMarcas = (query) => ({
    type: GET_COMBO_MARCAS,
    payload: api.getComboMarcas(query)
});
export const obtenerComboPais = (query) => ({
    type: GET_COMBO_PAIS,
    payload: api.getComboPais(query)
});
export const obtenerComboComunas = (query) => ({
    type: GET_COMBO_COMUNAS,
    payload: api.getComboComunas(query)
});
export const enviarActualizacionImplicado = (newImplicado) => ({
    type: POST_ACTUALIZAR_IMPLICADO,
    payload: api.actualizarImplicado(newImplicado)
});
export const obtenerDatosNoFormato = (datosNoformatos) => ({
    type:OBTENER_DATOS_NO_FORMATOS,
    payload: datosNoformatos
});
export const obtenerRutConductor = (rut) => ({
    type:OBTENER_RUT_CONDUCTOR,
    payload: rut
});
export const obtenerRutPropietario = (rut) => ({
    type:OBTENER_RUT_PROPIETARIO,
    payload: rut
});